exports = module.exports = require("../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "::ng-deep .ag-theme-balham .ag-cell-inline-editing {\r\n    background-color: transparent;\r\n    height: 29px;\r\n    padding-left: 10px;\r\n    padding-right: 10px;\r\n}\r\n::ng-deep .ag-cell.ag-cell-with-height.ag-cell-no-focus.ag-cell-value.ag-cell-inline-editing {\r\n    z-index: 0;\r\n}\r\n.editor-container {\r\n    font-size: 13px;\r\n}\r\n.input-group.editor-group {\r\n    width: 100% !important;\r\n}\r\n.form-control.editor-input {\r\n    width: calc(100% - 60px);\r\n    height: 20px;\r\n    margin-top: 3px;\r\n    border-radius: 0px;\r\n    text-overflow: ellipsis;\r\n    overflow: hidden;\r\n}\r\n.input-group-text.editor-addon img {\r\n    margin: 3px 6px 0px 0px;\r\n}\r\n.lf-cancel {\r\n    height: 18px;\r\n}\r\n", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// /home/runner/work/fbm-fulfillment-wms-client/fbm-fulfillment-wms-client/src/app/shared/lookup/search-criteria-popup/search-criteria-cell-editor/search-criteria-cell-editor.component.css
// module id = ../../../../../src/app/shared/lookup/search-criteria-popup/search-criteria-cell-editor/search-criteria-cell-editor.component.css
// module chunks = main